import React from 'react';
import { MapPin, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
import salonImage from "../assets/images/about.jpg";

const StoreLocator = () => {
  const stores = [
    {
      name: "Scissors Professionals Unisex Luxury Salon (Agaram)",
      address: "1st floor, 47/21, Sundaraj Perumal Koil St S, opposite to SBI bank (TVK Branch), New Kamaraj Nagar, Agaram, Perambur, Chennai, Tamil Nadu 600082",
      mapLink: "https://maps.app.goo.gl/vNX1vNMA1kn6vyCD9",
      image: salonImage
    },
    {
      name: "Scissors Professionals Unisex Luxury Salon (Thoraipakkam)",
      address: "200ft, 47 Pillayar Kovil Street, Vaniyambadi Biriyani Upstairs, Road, Thoraipakkam, Chennai, Tamil Nadu 600097",
      mapLink: "https://maps.app.goo.gl/UGdvm1ZowFmF2x7k9",
      image: salonImage
    }
  ];

  return (
    <div className="pt-20">
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Store Locator</h1>
            <p className="text-lg text-gray-600">Find our luxury salon locations near you</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {stores.map((store, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <img
                  src={store.image}
                  alt={store.name}
                  className="w-full h-64 object-cover"
                />
                <div className="p-6">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">{store.name}</h2>
                  <div className="flex items-start gap-3 mb-6">
                    <MapPin className="w-5 h-5 text-gray-600 mt-1 flex-shrink-0" />
                    <p className="text-gray-700">{store.address}</p>
                  </div>
                  <a
                    href={store.mapLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button className="w-full bg-black hover:bg-gray-800 text-white flex items-center justify-center gap-2">
                      <MapPin size={18} />
                      View on Google Maps
                      <ExternalLink size={16} />
                    </Button>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default StoreLocator;
